import React from "react";
import { Card, Nav } from "react-bootstrap";
import { Link } from 'react-router-dom';
//import '../../styles/admin.css'
import { useLocation } from 'react-router-dom';
import { logoutUser } from "../../services/authService";

const Sidebar = props => {
  const currentLocation = useLocation();

  return (
    <>
      <Card>
      <Nav defaultActiveKey="/home" className="flex-column admin-sidebar">
        <Link to='/admin/main' className={currentLocation.pathname === '/admin/main' && 'active'}>Editar COntenido principal</Link>
        <Link to='/admin/migration' className={currentLocation.pathname === '/admin/migration' && 'active'}>Editar Migración</Link>
        <Link to="/admin/mobility" className={currentLocation.pathname === '/admin/mobility' && 'active'}>Editar Movilidad</Link>
        <Link to='/admin/segregation' className={currentLocation.pathname === '/admin/segregation' && 'active'}>Editar Segregación</Link>
        <Link to='/admin/filter-features' className={currentLocation.pathname === '/admin/filter-features' && 'active'}>Editar Variables de Filtro</Link>
        <Link to='/admin/derived-features' className={currentLocation.pathname === '/admin/derived-features' && 'active'}>Editar Variables para derivar</Link>
        <Link to='/admin/segregation-features' className={currentLocation.pathname === '/admin/segregation-features' && 'active'}>Editar Variables para segregar</Link>
        <Link to='/admin/layers-configuration' className={currentLocation.pathname === '/admin/layers-configuration' && 'active'}>Editar rutas de capas</Link>
        <Link to='/admin/observatory-pages' className={currentLocation.pathname === '/admin/observatory-pages' && 'active'}>Observatorio</Link>
        <Link to='/admin/resources' className={currentLocation.pathname === '/admin/resources' && 'active'}>Gestionar recursos</Link>
        <Link to='/admin/change-password' className={currentLocation.pathname === '/admin/change-password' && 'active'}>Cambiar contraseña</Link>
        <Link to='/' onClick={() => {logoutUser()}} >Cerrar Sesión</Link>
      </Nav>
      </Card>
    </>
  );
  
}

export default Sidebar;